import { AppDate, parseAppDate, toAppDate } from '@macs-frontend/core/utils/date';
import { toDate } from '@macs-frontend/core/utils/date-utils';
import { function as F, option as O } from 'fp-ts';
import { NgrxValueConverter } from 'ngrx-forms';

export const dateValueConverter: NgrxValueConverter<
  Date | AppDate | null,
  AppDate | null
> = {
  convertViewToStateValue(value) {
    return F.pipe(value, O.fromNullable, O.map(F.flow(toDate, toAppDate)), O.toNullable);
  },
  convertStateToViewValue(value) {
    return F.pipe(value, O.fromNullable, O.map(parseAppDate), O.toNullable);
  },
};
